export default "__VITE_PUBLIC_ASSET__4253d687__"